import {
  isPlanBuilder,
  isPlanBuildableForDevice,
  getPlanBuilderDataForDevice
} from "./plan-selectors"

const getNormalPlanMinimumCost = (deviceID, state) => {
  return state.plans.allIDs
    .filter(planID => state.plans.byID[planID].devices[deviceID])
    .reduce((minCost, planID) => {
      let { maf } = state.plans.byID[planID].devices[deviceID]
      if (state.plans.options.excludeVAT) {
        maf = maf / state.plans.options.vatDivider
      }
      if (minCost === null) {
        return maf
      }
      return maf < minCost ? maf : minCost
    }, null)
}

const getBuildablePlanMinimumCost = (deviceID, state) => {
  const buildablePlanData = getPlanBuilderDataForDevice(deviceID, state)

  if (!buildablePlanData) return 0

  const highestUpfront = buildablePlanData.upfront.max
  const highestMonths = buildablePlanData.months.max
  const lowestData = buildablePlanData.data.sort((a, b) => a.cost - b.cost)[0]

  return (
    ((buildablePlanData.deviceCost - highestUpfront) / highestMonths +
      lowestData.cost) *
    buildablePlanData.multiplier
  )
}

// A selector to just grab all the devices with a calculated minimum cost based on MAF
export const getAllDevicesSelector = state => {
  const isPlanBuildable = isPlanBuilder(state)

  return state.devices.allIDs.map(id => {
    const minimumCost =
      isPlanBuildable && isPlanBuildableForDevice(id, state)
        ? getBuildablePlanMinimumCost(id, state)
        : getNormalPlanMinimumCost(id, state)

    return { ...state.devices.byID[id], id, minimumCost }
  })
}
